interface HeaderProps {
  title: string
  description: string
}

export default function Header({ title, description }: HeaderProps) {
  return (
    <header className="header">
      <div className="container">
        <div className="header-brand">
          <a href="https://aicoding.club" className="logo-link">
            <img src={`${import.meta.env.BASE_URL}logo.svg`} alt="AI Coding Club" className="logo" />
            <span className="brand-name">AI Coding Club</span>
          </a>
        </div>

        <div className="header-content">
          <h1>{title}</h1>
          <p className="subtitle">{description}</p>
        </div>

        <nav className="header-nav">
          <a href="https://aicoding.club/tools" className="nav-link">
            ← Back to Tools
          </a>
        </nav>
      </div>
    </header>
  )
}
